module.exports = __webpack_public_path__ + "img/icon_service.4619ec5a.png";